import Vue, { PropType } from 'vue';
import IconBase from '../icon';
import { IconProps, SVGJson } from '../utils/types';
import useSizeProps from '../utils/use-size-props';

const element: SVGJson = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"shop-1"},"children":[{"tag":"path","attrs":{"id":"fill1","fill":"props.fillColor1","d":"M21 3H3V21H21V3Z"}},{"tag":"g","attrs":{"id":"fill2"},"children":[{"tag":"path","attrs":{"fill":"props.fillColor2","d":"M9 6V3H3V6C3 7.65685 4.34315 9 6 9C7.65685 9 9 7.65685 9 6Z"}},{"tag":"path","attrs":{"fill":"props.fillColor2","d":"M9 6V3H15V6C15 7.65685 13.6569 9 12 9C10.3431 9 9 7.65685 9 6Z"}},{"tag":"path","attrs":{"fill":"props.fillColor2","d":"M15 6V3H21V6C21 7.65686 19.6569 9 18 9C16.3431 9 15 7.65685 15 6Z"}},{"tag":"path","attrs":{"fill":"props.fillColor2","d":"M15 14H9V21H15V14Z"}}]},{"tag":"path","attrs":{"id":"stroke2","stroke":"props.strokeColor2","d":"M9 3V6M9 3H3V6C3 7.65685 4.34315 9 6 9C7.65685 9 9 7.65685 9 6M9 3H15M9 6C9 7.65685 10.3431 9 12 9C13.6569 9 15 7.65685 15 6M15 3V6M15 3H21V6C21 7.65685 19.6569 9 18 9C16.3431 9 15 7.65685 15 6M9 14H15V21H9V14Z","strokeWidth":"props.strokeWidth"}},{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M21 3H3V21H21V3Z","strokeWidth":"props.strokeWidth"}}]}]};

const Shop1 = Vue.extend<IconProps>({
  name: 'Shop1Icon',
  functional: true,
  props: {
    size: {
      type: String,
    },
    onClick: {
      type: Function as PropType<IconProps['onClick']>,
    },
    fillColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeWidth: {
      type: Number,
      default: 2
    }
  },
  render(createElement, context) {
    const { props, data } = context;
    const { size, ...otherProps } = props;

    const { className, style } = useSizeProps(size);
    const fullProps = {
      ...otherProps || {},
      id: 'shop-1',
      icon: element,
      staticClass: className,
      style,
    };
    data.props = fullProps;
    return createElement(IconBase, data);
  },
});

export default Shop1;
